
  <div class="col-12 md:col-12 lg:col-12" style="height: 400px;">
    <div id="driverLocationMap" class="map"></div>
  </div>

  <p-toast key="message"> </p-toast>

